import Tax1099Logo from './vectors/Tax1099Logo'
import PreLoginImage from './vectors/PreLoginImage'
import UserProfile from './vectors/UserProfile'
import EmailIcon from './vectors/EmailIcon'
import PasswordIcon from './vectors/PasswordIcon'
import TogglePasswordIcon from './vectors/TogglePasswordIcon'
import DashboardIcon from './vectors/DashboardIcon'
import FormsIcon from './vectors/FormsIcon'
import NoticesIcon from './vectors/NoticesIcon'
import PayerIcon from './vectors/PayerIcon'
import RecipientIcon from './vectors/RecipientIcon'
import ReportsIcon from './vectors/ReportsIcon'
import SupportIcon from './vectors/SupportIcon'
import UsersIcon from './vectors/UsersIcon'
import CaretDown from './vectors/CaretDown'
import Close from './vectors/Close'
import FooterImage from './vectors/FooterImage'
import { VEC_ICON_NAME } from './constants'
import CircularCheckBox from './vectors/CircularCheckBox'
import UploadFromComputerIcon from './vectors/UploadFromComputerIcon'
import InfoIcon from './vectors/InfoIcon'
import WalletIcon from './vectors/WalletIcon'
import PreLoginFeatureIcon1 from './vectors/PreLoginFeatureIcon1'
import PreLoginFeatureIcon2 from './vectors/PreLoginFeatureIcon2'
import PreLoginFeatureIcon3 from './vectors/PreLoginFeatureIcon3'
import GoogleLoginIcon from './vectors/GoogleLoginIcon'
import QuickBooksLoginIcon from './vectors/QuickBooksLoginIcon'
import AzureLoginIcon from './vectors/AzureLoginIcon'
import GetCompanyStepIcon from './vectors/GetCompanyStepIcon'
import WelcomeStepIcon from './vectors/WelcomeStepIcon'
import ApiIntegrationIcon from './vectors/ApiIntegrationIcon'
import Logout from './vectors/Logout'
import PayerTypeIndividual from './vectors/PayerTypeIndividual'
import PayerTypeBusiness from './vectors/PayerTypeBusiness'
import IconDropdownCaret from './vectors/IconDropdownCaret'
import CheckBoxIcon from './vectors/CheckBoxIcon'
import SearchIcon from './vectors/SearchIcon'
import RadioButtonIcon from './vectors/RadioButtonIcon'
import PayerAddedSuccess from './vectors/PayerAddedSuccess'
import CircularPlusIcon from './vectors/CircularPlusIcon'
import CircularLeftArrow from './vectors/CircularLeftArrow'
import CircularRightArrow from './vectors/CircularRightArrow'
import DownloadIcon from './vectors/DownloadIcon'
import DragAndDropFileIcon from './vectors/DragAndDropFileIcon'
import BulkPayerSuccessIcon from './vectors/BulkPayerSuccessIcon'
import PayerTypeIndividualSmall from './vectors/PayerTypeIndividualSmall'
import PayerTypeBusinessSmall from './vectors/PayerTypeBusinessSmall'
import DownloadIconV2 from './vectors/DownloadIconV2'
import WarningIcon from './vectors/WarningIcon'
import TradeIcon from './vectors/TradeIcon'
import SortIcon from './vectors/SortIcon'
import FilterIcon from './vectors/FilterIcon'
import PhoneIcon from './vectors/PhoneIcon'
import ClientIcon from './vectors/ClientIcon'
import HomeIcon from './vectors/HomeIcon'
import CircularTickIcon from './vectors/CircularTickIcon'
import EmailGreyIcon from './vectors/EmailGreyIcon'
import BuisnessIcon from './vectors/BusinessIcon'
import UserIcon from './vectors/UserIcon'
import AlertIcon from './vectors/AlertIcon'
import MultipleSelectIcon from './vectors/MultipleSelectIcon'
import AssignToUserIcon from './vectors/AssignToUserIcon'
import ReportIcon from './vectors/ReportIcon'
import DeactivateIcon from './vectors/DeactivateIcon'
import DeleteIcon from './vectors/DeleteIcon'
import CheckboxDashIcon from './vectors/CheckboxDashIcon'
import BankLogoIcon from './vectors/BankLogoIcon'
import InvoiceLogoIcon from './vectors/InvoiceLogoIcon'
import ExcelSheetLogo from './vectors/ExcelSheetLogo'
import CsvFileLogo from './vectors/CsvFileLogo'
import XlsxFileLogo from './vectors/XlsxFileLogo'
import DocFileLogo from './vectors/DocFileLogo'
import DefaultFileLogo from './vectors/DefaultFileLogo'
import CreateFormSuccess from './vectors/CreateFormSuccess'
import CreateFormSuccessPayerIcon from './vectors/CreateFormSuccessPayerIcon'
import CreateFormSuccessRecipientIcon from './vectors/CreateFormSuccessRecipientIcon'
import VisaCardIcon from './vectors/VisaCardIcon'
import StarTickIcon from './vectors/StarTickIcon'
import CircularExclamatory from './vectors/CircularExclamatory'
import CopyIcon from './vectors/CopyIcon'
import EditIcon from './vectors/EditIcon'
import ProgressIcon from './vectors/ProgressIcon'
import PayerIcon2 from './vectors/PayerIcon2'
import RecipientIcon2 from './vectors/RecipientIcon2'
import ReadyToSubmit from './vectors/ReadyToSubmit'
import AlertIconSM from './vectors/AlertIconSM'
import IndividualFormIcon from './vectors/IndividualFormIcon'
import IndividualRoundIcon from './vectors/IndividualRoundIcon'
import WalletIconWithBox from './vectors/WalletIconWithBox'
import TwoFAIcon from "./vectors/TwoFAIcon"
import UpgradePlanIcon from './vectors/upgradePlanIcon'
import LogOutIcon from './vectors/logOutIcon'
import HelpSupportIcon from './vectors/helpSupportIcon'
import ChangePasswordIcon from './vectors/changePasswordIcon'
import ActivityLogIcon from './vectors/activityLogIcon'
import ChangePasswordPageVector from './vectors/changePasswordPageVector'
import GreenCheckMark from './vectors/greenCheckMark'
import ProfileEditIcon from './vectors/profileEditIcon'
import TickGreenIcon from './vectors/tickGreenIcon'
import RedCrossIcon from './vectors/redCrossIcon'
import TwoFAVector from './vectors/twoFAVector'
import EssentialVector from './vectors/EssentialVector'
import EFilePlusVector from './vectors/EFilePlusVector'
import EnterpriseVector from './vectors/EnterpriseVector'
import HistoryIcon from './vectors/HistoryIcon'
import PaymentSuccessDrawerIcon from './vectors/PaymentSuccessDrawerIcon'
import StarIcon from './vectors/StarIcon'
import ApiIcon from './vectors/ApiIcon'
import PointerIcon from './vectors/PointerIcon'
import NeedHelp from './vectors/NeedHelp'
import CreateFormVector from './vectors/CreateFormVector'
import AddPayersVector from './vectors/AddPayersVector'
import AddRecipientVector from './vectors/AddRecipientVector'
import ExplainPlanVector from './vectors/ExplainPlanVector'
import GeneralIcon from './vectors/GeneralIcon'
import CreateFormVectorMini from './vectors/CreateFormVectorMini'
import AddPayersVectorMini from './vectors/AddPayerVectorMini'
import AddRecipientVectorMini from './vectors/AddRecipientVectorMini'
import RightArrowOutline from './vectors/RightArrowOutline'
import ShortcutIcon from './vectors/ShortcutsIcon'
import NewTabIcon from './vectors/NewTabIcon'
import PDFIcon from './vectors/PDFIcon'
import HorizontalEllipsis from './vectors/HorizontalEllipsis'
import ViewIcon from './vectors/ViewIcon'
import ShareIcon from './vectors/ShareIcon'
import RevokeIcon from './vectors/RevokeIcon'
import ErrorIcon from './vectors/ErrorIcon'
import ImportIcon from './vectors/ImportIcon'
import RecommendFormIcon from './vectors/RecommendFormIcon'
import EFilePlusRibbon from './vectors/EFilePlusRibbon'
import EnterpriseRibbon from './vectors/EnterpriseRibbon'
import EssentialRibbon from './vectors/EssentialRibbon'
import BulkImportIcon from './vectors/BulkImportIcon'
import ThreeDotMenu from './vectors/ThreeDotMenu'
import ChatIcon from './vectors/ChatIcon'
import DragIcon from './vectors/DragIcon'
import ExportIcon from './vectors/ExportIcon';
import RecipeintDetailsIcon from './vectors/RecipeintDetailsIcon';
import SubmitFormIcon from './vectors/SubmitFormIcon';
import BillDueIcon from './vectors/BillDueIcon';
import TinVerificationMini from './vectors/TinVerificationMini';
import FormsMiniCTAIcon from './vectors/FormsMiniCTAIcon'
import QuickBooksDesktopLogo from './vectors/QuickBooksDesktopLogo'
import QuickBooksOnlineLogo from './vectors/QuickBooksOnlineLogo'
import BillLogo from './vectors/BillLogo'
import XeroLogo from './vectors/XeroLogo'
import ZohoBooksLogo from './vectors/ZohoBooksLogo'
import SageLogo from './vectors/SageLogo'
import OracleNetsuiteLogo from './vectors/OracleNetsuiteLogo'
import EntrataLogo from './vectors/EntrataLogo'
import FreshBooksLogo from './vectors/FreshBooksLogo'
import AccountingSuiteLogo from './vectors/AccountingSuiteLogo'
import TipaltiLogo from './vectors/TipaltiLogo'
import W9PDFImportLogo from './vectors/W9PDFImportLogo'
import ExcelImportLogo from './vectors/ExcelImportLogo'
import AppleLoginIcon from './vectors/AppleLoginIcon'
import ManageCardsLogo from './vectors/ManageCardsLogo'
import HelpInfoIcon from './vectors/HelpInfoIcon'
import FincenBOIBarGraph from './vectors/FincenBOIBarGraph'
import FincenBoiSideBarVect from './vectors/FincenBoiSideBarVect'
import AllMenuIcon from './vectors/AllMenuIcon'
import FBAROnlineIcon from './vectors/FBAROnlineIcon'
import EZExtensionIcon from './vectors/EZExtensionIcon'
import EZ2290Icon from './vectors/EZ2290Icon'
import PaperScrollIcon from './vectors/PaperScrollIcon'
import BoiBoyWQuestionIcon from './vectors/BoiBoyWQuestionIcon'
import BoiGirlIcon from './vectors/BoiGirlIcon'
import BoiQuizCompletionIcon from './vectors/BoiQuizCompletionIcon'
import SubmitPaymentIcon from './vectors/SubmitPaymentIcon'
import AddPayerIcon from './vectors/AddPayerIcon'
import CreateFormIcon from './vectors/CreateFormIcon'

export default function LocalIcons({ iconName, color, style = {}, transformScale, rotateDeg = 0 }) {

    const iconProps = {
        style: {
            ...style,
            transform: `scale(${transformScale}) rotate(${rotateDeg}deg)`,
        },
        fill: color,
        stroke: color,
    }

    switch (iconName) {
        case VEC_ICON_NAME.TAX1099_LOGO:
            return <Tax1099Logo {...iconProps} />
        case VEC_ICON_NAME.PRE_LOGIN_IMAGE:
            return <PreLoginImage {...iconProps} />
        case VEC_ICON_NAME.USER_PROFILE:
            return <UserProfile {...iconProps} />
        case VEC_ICON_NAME.EMAIL_ICON:
            return <EmailIcon {...iconProps} />
        case VEC_ICON_NAME.PASSWORD_ICON:
            return <PasswordIcon {...iconProps} />
        case VEC_ICON_NAME.TOGGLE_PASSWORD_ICON:
            return <TogglePasswordIcon {...iconProps} />
        case VEC_ICON_NAME.DASHBOARD_ICON:
            return <DashboardIcon {...iconProps} />
        case VEC_ICON_NAME.FORMS_ICON:
            return <FormsIcon {...iconProps} />
        case VEC_ICON_NAME.NOTICES_ICON:
            return <NoticesIcon {...iconProps} />
        case VEC_ICON_NAME.PAYER_ICON:
            return <PayerIcon {...iconProps} />
        case VEC_ICON_NAME.RECIPIENT_ICON:
            return <RecipientIcon {...iconProps} />
        case VEC_ICON_NAME.REPORTS_ICON:
            return <ReportsIcon {...iconProps} />
        case VEC_ICON_NAME.HISTORY_ICON:
            return <HistoryIcon {...iconProps} />
        case VEC_ICON_NAME.SUPPORT_ICON:
            return <SupportIcon {...iconProps} />
        case VEC_ICON_NAME.USERS_ICON:
            return <UsersIcon {...iconProps} />
        case VEC_ICON_NAME.CARET_DOWN:
            return <CaretDown {...iconProps} />
        case VEC_ICON_NAME.CLOSE:
            return <Close {...iconProps} />
        case VEC_ICON_NAME.FOOTER_IMAGE:
            return <FooterImage {...iconProps} />
        case VEC_ICON_NAME.CIRCULAR_CHECKBOX:
            return <CircularCheckBox {...iconProps} />
        case VEC_ICON_NAME.UPLOAD_FROM_COMPUTER:
            return <UploadFromComputerIcon {...iconProps} />
        case VEC_ICON_NAME.INFO_ICON:
            return <InfoIcon {...iconProps} />
        case VEC_ICON_NAME.WALLET_ICON:
            return <WalletIcon {...iconProps} />
        case VEC_ICON_NAME.PRE_LOGIN_FEATURE_ICON1:
            return <PreLoginFeatureIcon1 {...iconProps} />
        case VEC_ICON_NAME.PRE_LOGIN_FEATURE_ICON2:
            return <PreLoginFeatureIcon2 {...iconProps} />
        case VEC_ICON_NAME.PRE_LOGIN_FEATURE_ICON3:
            return <PreLoginFeatureIcon3 {...iconProps} />
        case VEC_ICON_NAME.GOOGLE_LOGIN_ICON:
            return <GoogleLoginIcon {...iconProps} />
        case VEC_ICON_NAME.APPLE_LOGIN_ICON:
            return <AppleLoginIcon />
        case VEC_ICON_NAME.QUICK_BOOKS_LOGIN_ICON:
            return <QuickBooksLoginIcon {...iconProps} />
        case VEC_ICON_NAME.AZURE_LOGIN_ICON:
            return <AzureLoginIcon {...iconProps} />
        case VEC_ICON_NAME.GET_COMPANY_STEP_ICON:
            return <GetCompanyStepIcon {...iconProps} />
        case VEC_ICON_NAME.WELCOME_STEP_ICON:
            return <WelcomeStepIcon {...iconProps} />
        case VEC_ICON_NAME.API_INTEGRATION_ICON:
            return <ApiIntegrationIcon {...iconProps} />
        case VEC_ICON_NAME.LOGOUT:
            return <Logout {...iconProps} />
        case VEC_ICON_NAME.PAYER_TYPE_INDIVIDUAL:
            return <PayerTypeIndividual {...iconProps} />
        case VEC_ICON_NAME.PAYER_TYPE_BUSINESS:
            return <PayerTypeBusiness {...iconProps} />
        case VEC_ICON_NAME.ICON_DROPDOWN_CARET:
            return <IconDropdownCaret {...iconProps} />
        case VEC_ICON_NAME.CHECKBOX_ICON:
            return <CheckBoxIcon {...iconProps} />
        case VEC_ICON_NAME.SEARCH_ICON:
            return <SearchIcon {...iconProps} />
        case VEC_ICON_NAME.RADIO_BUTTON_ICON:
            return <RadioButtonIcon {...iconProps} />
        case VEC_ICON_NAME.PAYER_ADDED_SUCCESS:
            return <PayerAddedSuccess {...iconProps} />
        case VEC_ICON_NAME.CIRCULAR_PLUS_ICON:
            return <CircularPlusIcon {...iconProps} />
        case VEC_ICON_NAME.CIRCULAR_LEFT_ARROW:
            return <CircularLeftArrow {...iconProps} />
        case VEC_ICON_NAME.CIRCULAR_RIGHT_ARROW:
            return <CircularRightArrow {...iconProps} />
        case VEC_ICON_NAME.DOWNLOAD_ICON:
            return <DownloadIcon {...iconProps} />
        case VEC_ICON_NAME.DRAG_AND_DROP_FILE_ICON:
            return <DragAndDropFileIcon {...iconProps} />
        case VEC_ICON_NAME.BULK_PAYER_ADDED_SUCCESS:
            return <BulkPayerSuccessIcon {...iconProps} />
        case VEC_ICON_NAME.PAYER_TYPE_INDIVIDUAL_SMALL:
            return <PayerTypeIndividualSmall {...iconProps} />
        case VEC_ICON_NAME.PAYER_TYPE_BUSINESS_SMALL:
            return <PayerTypeBusinessSmall {...iconProps} />
        case VEC_ICON_NAME.DOWNLOAD_ICON_V2:
            return <DownloadIconV2 {...iconProps} />
        case VEC_ICON_NAME.WARNING_ICON:
            return <WarningIcon {...iconProps} />
        case VEC_ICON_NAME.TRADE_ICON:
            return <TradeIcon {...iconProps} />
        case VEC_ICON_NAME.SORT_ICON:
            return <SortIcon {...iconProps} />
        case VEC_ICON_NAME.FILTER_ICON:
            return <FilterIcon {...iconProps} />
        case VEC_ICON_NAME.USER_ICON:
            return <UserIcon {...iconProps} />
        case VEC_ICON_NAME.PHONE_ICON:
            return <PhoneIcon {...iconProps} />
        case VEC_ICON_NAME.BUISNESS_ICON:
            return <BuisnessIcon {...iconProps} />
        case VEC_ICON_NAME.CLIENT_ICON:
            return <ClientIcon {...iconProps} />
        case VEC_ICON_NAME.HOME_ICON:
            return <HomeIcon {...iconProps} />
        case VEC_ICON_NAME.CIRCULAR_TICK_ICON:
            return <CircularTickIcon {...iconProps} />
        case VEC_ICON_NAME.EMAIL_GREY_ICON:
            return <EmailGreyIcon {...iconProps} />
        case VEC_ICON_NAME.ALERT_ICON:
            return <AlertIcon {...iconProps} />
        case VEC_ICON_NAME.MULTIPLE_SELECT_ICON:
            return <MultipleSelectIcon {...iconProps} />
        case VEC_ICON_NAME.ASSIGN_TO_USER_ICON:
            return <AssignToUserIcon {...iconProps} />
        case VEC_ICON_NAME.REPORT_ICON:
            return <ReportIcon {...iconProps} />
        case VEC_ICON_NAME.DEACTIVATE_ICON:
            return <DeactivateIcon {...iconProps} />
        case VEC_ICON_NAME.DELETE_ICON:
            return <DeleteIcon {...iconProps} />
        case VEC_ICON_NAME.CHECKBOX_DASH_ICON:
            return <CheckboxDashIcon {...iconProps} />
        case VEC_ICON_NAME.BANK_LOGO_ICON:
            return <BankLogoIcon {...iconProps} />
        case VEC_ICON_NAME.INVOICE_LOGO_ICON:
            return <InvoiceLogoIcon {...iconProps} />
        case VEC_ICON_NAME.EXCEL_SHEET_LOGO:
            return <ExcelSheetLogo {...iconProps} />
        case VEC_ICON_NAME.CSV_FILE_LOGO:
            return <CsvFileLogo {...iconProps} />
        case VEC_ICON_NAME.XLSX_FILE_LOGO:
            return <XlsxFileLogo {...iconProps} />
        case VEC_ICON_NAME.DOC_FILE_LOGO:
            return <DocFileLogo {...iconProps} />
        case VEC_ICON_NAME.DEFAULT_FILE_LOGO:
            return <DefaultFileLogo {...iconProps} />
        case VEC_ICON_NAME.CREATE_FORM_SUCCESS_RECIPIENT_ICON:
            return <CreateFormSuccessRecipientIcon {...iconProps} />
        case VEC_ICON_NAME.CREATE_FORM_SUCCESS_PAYER_ICON:
            return <CreateFormSuccessPayerIcon {...iconProps} />
        case VEC_ICON_NAME.CREATE_FORM_SUCCESS:
            return <CreateFormSuccess {...iconProps} />
        case VEC_ICON_NAME.VISA:
            return <VisaCardIcon {...iconProps} />
        case VEC_ICON_NAME.START_TICK_ICON:
            return <StarTickIcon {...iconProps} />
        case VEC_ICON_NAME.CIRCULAR_EXCLAMATORY:
            return <CircularExclamatory {...iconProps} />
        case VEC_ICON_NAME.COPY_ICON:
            return <CopyIcon {...iconProps} />
        case VEC_ICON_NAME.EDIT_ICON:
            return <EditIcon {...iconProps} />
        case VEC_ICON_NAME.PROGRESS_ICON:
            return <ProgressIcon {...iconProps} />
        case VEC_ICON_NAME.PAYER_ICON_2:
            return <PayerIcon2 {...iconProps} />
        case VEC_ICON_NAME.RECIPIENT_ICON_2:
            return <RecipientIcon2 {...iconProps} />
        case VEC_ICON_NAME.READY_TO_SUBMIT:
            return <ReadyToSubmit {...iconProps} />
        case VEC_ICON_NAME.ALERT_ICON_SM:
            return <AlertIconSM {...iconProps} />
        case VEC_ICON_NAME.INDIVIDUAL_FORM_ICON:
            return <IndividualFormIcon {...iconProps} />
        case VEC_ICON_NAME.INDIVIDUAL_ROUND_ICON:
            return <IndividualRoundIcon {...iconProps} />
        case VEC_ICON_NAME.WALLET_ICON_WITH_BOX:
            return <WalletIconWithBox {...iconProps} />
        case VEC_ICON_NAME.TWO_FA_ICON:
            return <TwoFAIcon {...iconProps} />
        case VEC_ICON_NAME.UPGRADE_PLAN_ICON:
            return <UpgradePlanIcon {...iconProps} />
        case VEC_ICON_NAME.LOGOUT_ICON:
            return <LogOutIcon {...iconProps} />
        case VEC_ICON_NAME.HELP_SUPPORT_ICON:
            return <HelpSupportIcon {...iconProps} />
        case VEC_ICON_NAME.CHANGE_PASSWORD_ICON:
            return <ChangePasswordIcon {...iconProps} />
        case VEC_ICON_NAME.ACTIVITY_LOG_ICON:
            return <ActivityLogIcon {...iconProps} />
        case VEC_ICON_NAME.CHANGE_PASSWORD_PAGE_VECTOR:
            return <ChangePasswordPageVector {...iconProps} />
        case VEC_ICON_NAME.GREEN_CHECK_MARK:
            return <GreenCheckMark {...iconProps} />
        case VEC_ICON_NAME.PROFILE_EDIT_ICON:
            return <ProfileEditIcon {...iconProps} />
        case VEC_ICON_NAME.GREEN_TICK_ICON:
            return <TickGreenIcon {...iconProps} />
        case VEC_ICON_NAME.RED_CROSS_ICON:
            return <RedCrossIcon {...iconProps} />
        case VEC_ICON_NAME.TWO_FA_VECTOR:
            return <TwoFAVector {...iconProps} />
        case VEC_ICON_NAME.ESSENTIAL_VECTOR:
            return <EssentialVector {...iconProps} />
        case VEC_ICON_NAME.EFILE_PLUS_VECTOR:
            return <EFilePlusVector {...iconProps} />
        case VEC_ICON_NAME.ENTERPRISE_VECTOR:
            return <EnterpriseVector {...iconProps} />
        case VEC_ICON_NAME.PAYMENT_SUCCESS_DRAWER_ICON:
            return <PaymentSuccessDrawerIcon {...iconProps} />
        case VEC_ICON_NAME.STAR_ICON:
            return <StarIcon {...iconProps} />
        case VEC_ICON_NAME.API_ICON:
            return <ApiIcon {...iconProps} />
        case VEC_ICON_NAME.POINTER_ICON:
            return <PointerIcon {...iconProps} />
        case VEC_ICON_NAME.NEED_HELP_ICON:
            return <NeedHelp {...iconProps} />
        case VEC_ICON_NAME.CREATE_FORM_VECTOR:
            return <CreateFormVector {...iconProps} />
        case VEC_ICON_NAME.ADD_PAYER_VECTOR:
            return <AddPayersVector {...iconProps} />
        case VEC_ICON_NAME.ADD_RECIPIENT_VECTOR:
            return <AddRecipientVector {...iconProps} />
        case VEC_ICON_NAME.EXPLORE_PLAN_VECTOR:
            return <ExplainPlanVector {...iconProps} />
        case VEC_ICON_NAME.GENERAL_ICON:
            return <GeneralIcon {...iconProps} />
        case VEC_ICON_NAME.CREATE_FORM_VECTOR_MINI:
            return <CreateFormVectorMini {...iconProps} />
        case VEC_ICON_NAME.ADD_PAYER_VECTOR_MINI:
            return <AddPayersVectorMini {...iconProps} />
        case VEC_ICON_NAME.ADD_RECIPIENT_VECTOR_MINI:
            return <AddRecipientVectorMini {...iconProps} />
        case VEC_ICON_NAME.RIGHT_ARROW_OUTLINE:
            return <RightArrowOutline {...iconProps} />
        case VEC_ICON_NAME.SHORTCUT_ICON:
            return <ShortcutIcon {...iconProps} />
        case VEC_ICON_NAME.NEW_TAB_ICON:
            return <NewTabIcon {...iconProps} />
        case VEC_ICON_NAME.PDF_ICON:
            return <PDFIcon {...iconProps} />
        case VEC_ICON_NAME.HORIZONTAL_ELLIPSIS:
            return <HorizontalEllipsis {...iconProps} />
        case VEC_ICON_NAME.VIEW_ICON:
            return <ViewIcon {...iconProps} />
        case VEC_ICON_NAME.SHARE_ICON:
            return <ShareIcon {...iconProps} />
        case VEC_ICON_NAME.REVOKE_ICON:
            return <RevokeIcon {...iconProps} />
        case VEC_ICON_NAME.ERROR_ICON:
            return <ErrorIcon {...iconProps} />
        case VEC_ICON_NAME.IMPORT_ICON:
            return <ImportIcon {...iconProps} />
        case VEC_ICON_NAME.FORM_RECOMMEND_ICON:
            return <RecommendFormIcon  {...iconProps}/>
        case VEC_ICON_NAME.EFILE_PLUS_RIBBON:
            return <EFilePlusRibbon {...iconProps} />
        case VEC_ICON_NAME.ENTERPRISE_RIBBON:
            return <EnterpriseRibbon {...iconProps} />
        case VEC_ICON_NAME.ESSENTIAL_RIBBON:
            return <EssentialRibbon {...iconProps} />
        case VEC_ICON_NAME.BULK_IMPORT_ICON:
            return <BulkImportIcon {...iconProps} />
        case VEC_ICON_NAME.THREE_DOT_MENU_ICON:
            return <ThreeDotMenu {...iconProps} />
        case VEC_ICON_NAME.CHAT_ICON:
            return <ChatIcon {...iconProps} />
        case VEC_ICON_NAME.DRAG_ICON:
            return <DragIcon {...iconProps} />
        case VEC_ICON_NAME.EXPORT_ICON:
            return <ExportIcon {...iconProps} />
        case VEC_ICON_NAME.RECIPIENT_DETAILS_ICON:
            return <RecipeintDetailsIcon {...iconProps} />
        case VEC_ICON_NAME.SUBMIT_FORM_ICON:
            return <SubmitFormIcon {...iconProps} />
        case VEC_ICON_NAME.BILL_DUE_ICON:
            return <BillDueIcon {...iconProps} />
        case VEC_ICON_NAME.TIN_VERIFICATION_VECTOR_MINI:
            return <TinVerificationMini {...iconProps} />
        case VEC_ICON_NAME.FORMS_MINI_VECTOR:
            return <FormsMiniCTAIcon {...iconProps} />
        case VEC_ICON_NAME.QUICK_BOOKS_DESKTOP_LOGO:
            return <QuickBooksDesktopLogo {...iconProps} />
        case VEC_ICON_NAME.QUICK_BOOKS_ONLINE_LOGO:
            return <QuickBooksOnlineLogo {...iconProps} />
        case VEC_ICON_NAME.BILL_LOGO:
            return <BillLogo {...iconProps} />
        case VEC_ICON_NAME.XERO_LOGO:
            return <XeroLogo {...iconProps} />
        case VEC_ICON_NAME.ZOHO_BOOKS_LOGO:
            return <ZohoBooksLogo {...iconProps} />
        case VEC_ICON_NAME.ZOHO_BOOKS_LOGO:
            return <ZohoBooksLogo {...iconProps} />
        case VEC_ICON_NAME.SAGE_LOGO:
            return <SageLogo {...iconProps} />
        case VEC_ICON_NAME.ORACLE_NETSUITE_LOGO:
            return <OracleNetsuiteLogo {...iconProps} />
        case VEC_ICON_NAME.ENTRATA_LOGO:
            return <EntrataLogo {...iconProps} />
        case VEC_ICON_NAME.FRESH_BOOKS_LOGO:
            return <FreshBooksLogo {...iconProps} />
        case VEC_ICON_NAME.ACCOUNTING_SUITE_LOGO:
            return <AccountingSuiteLogo {...iconProps} />
        case VEC_ICON_NAME.TIPALTI_LOGO:
            return <TipaltiLogo {...iconProps} />
        case VEC_ICON_NAME.W9PDF_IMPORT_LOGO:
            return <W9PDFImportLogo {...iconProps} />
        case VEC_ICON_NAME.EXCEL_IMPORT_LOGO:
            return <ExcelImportLogo {...iconProps} />
        case VEC_ICON_NAME.MANAGE_CARDS_VECTOR:
            return <ManageCardsLogo {...iconProps} />
        case VEC_ICON_NAME.HELP_INFO_ICON:
            return <HelpInfoIcon {...iconProps} />
        case VEC_ICON_NAME.BOI_REPORTING_ICON:
            return <FincenBOIBarGraph {...iconProps} />
        case VEC_ICON_NAME.FINCEN_BOI_SIDEBAR_ICON:
            return <FincenBoiSideBarVect {...iconProps} />
        case VEC_ICON_NAME.ALL_MENU_ICON:
            return <AllMenuIcon {...iconProps} />
        case VEC_ICON_NAME.FBAR_ONLINE_ICON:
            return <FBAROnlineIcon {...iconProps} />
        case VEC_ICON_NAME.EZ_EXTENSION_ICON:
            return <EZExtensionIcon {...iconProps} />
        case VEC_ICON_NAME.EZ_2290_ICON:
            return <EZ2290Icon {...iconProps} />
        case VEC_ICON_NAME.PAPER_SCROLL_ICON:
            return <PaperScrollIcon {...iconProps} />
        case VEC_ICON_NAME.BOI_BOY_W_QUESTION_ICON:
            return <BoiBoyWQuestionIcon {...iconProps} />
        case VEC_ICON_NAME.BOI_GIRL_ICON:
            return <BoiGirlIcon {...iconProps} />
        case VEC_ICON_NAME.BOI_QUIZ_COMPLETION_ICON:
            return <BoiQuizCompletionIcon {...iconProps} />
        case VEC_ICON_NAME.SUBMIT_PAYMENT_ICON:
            return <SubmitPaymentIcon {...iconProps} />
        case VEC_ICON_NAME.ADD_PAYER_ICON:
            return <AddPayerIcon {...iconProps} />
        case VEC_ICON_NAME.CREATE_FORM_ICON:
            return <CreateFormIcon {...iconProps} />
        default:
            return <DashboardIcon {...iconProps} />
    }
}